// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.sesam-gc.ch';
